import { components } from 'shared/data/walletsKyc/v1';

export const buildCompanySectorInitialValues = (
    businessInformation: components['schemas']['FormBusinessInformationAnswer'] | undefined
) => ({
    noBusinessWebsite:
        typeof businessInformation?.noBusinessWebsite === 'boolean' ? businessInformation.noBusinessWebsite : false,
    documentIds: [],
    documents: undefined,
    documentSources: businessInformation?.documents?.map(({ id, documentImages }) => ({
        id,
        name: documentImages[0].name,
    })),
});
